import { Component, EventEmitter, Input, NgModule, OnInit, Output, inject } from '@angular/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { UntypedFormGroup } from '@angular/forms';
import {
  CheckboxOption,
  ReportFilterChange,
  SpeechOptionsFilter
} from '@src/app/features/reports/components/report-filters/models/report-filters.model';
import { ReportDictionariesService } from '@src/app/features/reports/components/report-filters/services/report-dictionaries.service';
import { ReportFiltersHelperService } from '@src/app/features/reports/components/report-filters/services/report-filters-helper.service';
import { FormModule } from '@shared/components/form/form.module';
import { CheckboxGroupComponent } from '@shared/components/form/components/checkbox-group/checkbox-group.component';

@Component({
  selector: 'stx-speech-options-filter',
  templateUrl: './speech-options-filter.component.html',
  imports: [CheckboxGroupComponent]
})
export class SpeechOptionsFilterComponent extends BaseComponent implements OnInit {
  private reportDictionariesService = inject(ReportDictionariesService);
  private reportFiltersHelperService = inject(ReportFiltersHelperService);

  @Input() filterName: SpeechOptionsFilter;
  @Input() formGroupReference: UntypedFormGroup;
  @Output() filterChange = new EventEmitter<ReportFilterChange>();
  speechOptions: CheckboxOption[];

  ngOnInit() {
    this.speechOptions = this.getCheckboxGroupOptions();
    this.reportFiltersHelperService.addCheckboxGroupOptionsToFormGroup(this.formGroupReference, this.speechOptions);
    this.subSink.sink = this.formGroupReference.valueChanges.subscribe(this.handleValueChanges.bind(this));
  }

  private handleValueChanges(change: Record<string, boolean>): void {
    const selectedSpeechOptions = this.reportFiltersHelperService.getSelectedCheckboxOptions(change);

    this.filterChange.emit({
      filterName: this.filterName,
      payload: {
        [this.filterName]: selectedSpeechOptions
      }
    });
  }

  private getCheckboxGroupOptions(): CheckboxOption[] {
    return this.reportFiltersHelperService.getCheckboxGroupOptionsFromDictionary(this.getFilterComponentDictionary());
  }

  private getFilterComponentDictionary() {
    switch (this.filterName) {
      case 'speechAssessmentStates':
        return this.reportDictionariesService.dictionaries.speechAssessmentStates;
      case 'speechTreatmentStates':
        return this.reportDictionariesService.dictionaries.speechTreatmentStates;
      case 'speechAssessmentRecommendations':
        return this.reportDictionariesService.dictionaries.speechAssessmentRecommendations;
      case 'speechQaReviewerGrades':
        return this.reportDictionariesService.dictionaries.speechQaReviewerGrades;
    }
  }
}

@NgModule({
  imports: [FormModule, SpeechOptionsFilterComponent],
  exports: [SpeechOptionsFilterComponent]
})
export class SpeechTypeModule {}
